export default "__VITE_ASSET__BWe_JSdi__"